import { getUID } from '@redviking/argonaut-util/src/getUID';
import type { NodeCfg } from '@redviking/argonaut-util/types/mes/applet-designs/flow.latest';
import type { NodeSpec } from './NodeSpec';
import { defineControlOpts } from '../../controls/FlowNodeControl';
import { defaultControlUpdateValueHandler } from '@redviking/argonaut-core-ui/src/applet/design/flows/controls/control-event-handler';

export const sliceUiNodeSpec: NodeSpec<NodeCfg<'slice'>> = {
    requiredSockets: () => ({
        conditionallyRequired: [],
        required: [ 'input', 'output', 'start', 'end' ],
    }),
    cfg: () => ({ id: getUID(), kind: 'slice', disabled: false }),
    controls: () => ({}),
    inputs: nodeCfg => ({
        end: {
            controlOpts: defineControlOpts({
                cfg: { kind: 'number' },
                on: { 'update:value': defaultControlUpdateValueHandler },
                value: (nodeCfg.socketDefaults?.inputs?.end as number | null) ?? null,
            }),
            socket: 'number',
            label: 'End Index (optional)',
            index: 2,
        },
        input: { socket: 'string', label: 'Input', index: 0 },
        start: {
            controlOpts: defineControlOpts({
                cfg: { kind: 'number' },
                on: { 'update:value': defaultControlUpdateValueHandler },
                value: (nodeCfg.socketDefaults?.inputs?.start as number | null) ?? 0,
            }),
            socket: 'number',
            label: 'Start Index',
            index: 1,
        },
    }),
    kindLabel: 'Text Slice',
    nodeCategory: 'text',
    outputs: () => ({ output: { socket: 'string', label: 'Output' } }),
    validator: () => true,
};
